import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { ApplicationSubtype, BoxSpg, DividerSpg } from "@duosoftbg/nacid-components";
import { Button, Typography } from "@mui/material";
import SignalDetailsSection from "./section/SignalDetailsSection";
import { completeSignalStep, setStepSignalEdited } from "../../../../../../store/redux/slice/Forms/signalForm";
import { createSignalDetailsValidationSchema } from "../../../../../../yup/signal/signalValidationSchemas";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import { initialSignalDetails } from "../../../../../../init/signalInitialValues";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import React from "react";

const SignalStepSignal = () => {
  const { t } = useTranslation();

  const signalForm = useAppSelector((state) => {
    return state.Forms.SignalForm;
  });

  const fullSchema = createSignalDetailsValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    signalForm.signalDetails,
    signalForm.id,
    baseEndpointPaths.signal,
    formalSchema,
    setStepSignalEdited,
    completeSignalStep,
    initialSignalDetails,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.SIGNAL, signalForm.signalDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
            console.log(errors);
          })}
        >
          <SignalDetailsSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default SignalStepSignal;
